import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Statistic,
  Progress,
  Spin,
  Button,
  ConfigProvider,
  Space,
} from "antd";
import {
  DashboardOutlined,
  ShoppingOutlined,
  DollarCircleOutlined,
  TeamOutlined,
  ShopOutlined,
  ReloadOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import "./dashboard.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Your specific get function
  const getStats = () => {
    let getRes = (res) => {
      console.log("res", res);
      // Logic to handle nested or direct data
      if (res?.data) {
        setStats(res.data);
      } else {
        setStats(res);
      }
      setIsLoading(false);
    };

    callApi(
      "GET",
      routes.adminDashboard,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.error("error fetching dashboard", error);
        setIsLoading(false);
      },
    );
  };

  useEffect(() => {
    getStats();
  }, []);

  // Format number to Nigerian Naira
  const formatNGN = (val) => `₦${Number(val || 0).toLocaleString()}`;

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#FFA450" } }}>
      <div className="dashboard-container">
        {/* --- Header Section --- */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <div>
            <h1 style={{ margin: 0, fontWeight: 700 }}>Dashboard Overview</h1>
            <small style={{ color: "#8c8c8c" }}>
              Real-time platform performance
            </small>
          </div>
          <Button
            icon={<ReloadOutlined />}
            onClick={getStats}
            loading={isLoading}
          >
            Refresh
          </Button>
        </div>

        {isLoading ? (
          <div style={{ textAlign: "center", marginTop: 100 }}>
            <Spin size="large" />
          </div>
        ) : (
          <Row gutter={[16, 16]}>
            {/* 1. Platform Revenue (Hero Card) */}
            <Col xs={24} md={8}>
              <Card className="stat-card-base revenue-card-accent">
                <Statistic
                  title="Platform Revenue"
                  value={stats?.platformRevenue}
                  formatter={formatNGN}
                  prefix={<RiseOutlined />}
                />
                <div
                  style={{
                    marginTop: 12,
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "12px",
                  }}
                >
                  Total earnings from platform fees
                </div>
              </Card>
            </Col>

            {/* 2. Total GMV */}
            <Col xs={12} md={8}>
              <Card className="stat-card-base">
                <div
                  className="stat-icon-circle"
                  style={{ background: "#f6ffed", color: "#52c41a" }}
                >
                  <DollarCircleOutlined />
                </div>
                <Statistic
                  title="Total GMV"
                  value={stats?.totalGrossMerchandiseValue}
                  formatter={formatNGN}
                />
              </Card>
            </Col>

            {/* 3. Total Orders */}
            <Col xs={12} md={8}>
              <Card className="stat-card-base">
                <div
                  className="stat-icon-circle"
                  style={{ background: "#fff7e6", color: "#ffa450" }}
                >
                  <ShoppingOutlined />
                </div>
                <Statistic title="Total Orders" value={stats?.totalOrders} />
              </Card>
            </Col>

            {/* 4. Vendor Performance Breakdown */}
            <Col xs={24} lg={12}>
              <Card title="Vendors Engagement" className="stat-card-base">
                <Row align="middle">
                  <Col span={16}>
                    <Statistic
                      title="Total Registered Vendors"
                      value={stats?.totalVendors}
                      prefix={<ShopOutlined />}
                    />
                    <div style={{ marginTop: 16 }}>
                      <span>Active vs Total</span>
                      <Progress
                        percent={Math.round(
                          (stats?.totalActiveVendors / stats?.totalVendors) *
                            100,
                        )}
                        strokeColor="#FFA450"
                        status="active"
                      />
                    </div>
                  </Col>
                  <Col span={8} style={{ textAlign: "center" }}>
                    <Statistic
                      title="Active"
                      value={stats?.totalActiveVendors}
                      valueStyle={{ color: "#52c41a" }}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>

            {/* 5. Customer Performance Breakdown */}
            <Col xs={24} lg={12}>
              <Card title="Customer Engagement" className="stat-card-base">
                <Row align="middle">
                  <Col span={16}>
                    <Statistic
                      title="Total Registered Customers"
                      value={stats?.totalCustomers}
                      prefix={<TeamOutlined />}
                    />
                    <div style={{ marginTop: 16 }}>
                      <span>Active vs Total</span>
                      <Progress
                        percent={Math.round(
                          (stats?.totalActiveCustomers /
                            stats?.totalCustomers) *
                            100,
                        )}
                        strokeColor="#722ed1"
                      />
                    </div>
                  </Col>
                  <Col span={8} style={{ textAlign: "center" }}>
                    <Statistic
                      title="Active"
                      value={stats?.totalActiveCustomers}
                      valueStyle={{ color: "#722ed1" }}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    </ConfigProvider>
  );
};

export default Dashboard;
